import { BiUser } from "react-icons/all";
import { Box, MenuItem, useColorModeValue, VStack } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { Icon } from "components/Icon";
import { ChakraText } from "components/ChakraText";
import { useGetThemeColors } from "ChakraTheme";

interface IProps {
  userName: string;
  userEmail: string;
  closeMenu: () => void;
}

const ProfileMenuItem = ({ userEmail, userName, closeMenu }: IProps) => {
  const colors = useGetThemeColors();
  const iconColor = useColorModeValue(colors.black, colors.white);

  const { friendlyUrl } = useGetFriendlyUrl();
  const history = useHistory();

  return (
    <Box id="logged-user-menu-profile-btn">
      <MenuItem
        icon={<Icon color={iconColor} w={5} h={5} icon={BiUser} />}
        onClick={() => {
          history.push(`/e-rezerwacja/${friendlyUrl}/uzytkownik/profil`);
          closeMenu();
        }}
      >
        <VStack alignItems="flex-start">
          <ChakraText fontWeight="bold">{userName}</ChakraText>
          <ChakraText>{userEmail}</ChakraText>
        </VStack>
      </MenuItem>
    </Box>
  );
};

export { ProfileMenuItem };
